import {createSlice, Dispatch, PayloadAction} from "@reduxjs/toolkit";
import DateUtils from "app/utils/DateUtils";
import {FilterAirportsQueryParams} from "../../../../types/service-types/AirportServiceTypes";
import {fetchAllAirports} from "./airports-list.slice";

const removeFalsyAttributes = (obj: any) => {
  let newObj: any = {};
  Object.keys(obj).forEach((prop) => {
    if (obj[prop]) {
      if (obj[prop] instanceof Date && !isNaN(Date.parse(obj[prop]))) {
        const convertedDate = DateUtils.convertToString(obj[prop]);
        newObj[prop] = convertedDate;
      } else if (obj[prop] instanceof Date && isNaN(Date.parse(obj[prop]))) {
      }
      if (prop === "fromDate" || prop === "toDate") {
        const convertedDate = DateUtils.convertToString(obj[prop]);
        newObj[prop] = convertedDate;
      } else if (obj[prop] === "ALL") {
      } else newObj[prop] = obj[prop];
    }
  });
  return newObj;
};

export const filterAirports =
    (queryParams: FilterAirportsQueryParams) =>
        async (dispatch: Dispatch) => {
          dispatch(setFilters(queryParams));
          // @ts-ignore
          dispatch(fetchAllAirports({...removeFalsyAttributes(queryParams)}));
        };

export const clearfilterAirports = () => async (dispatch: Dispatch) => {
  dispatch(setFilters(initialState));
};

const initialState: FilterAirportsQueryParams = {};

const stateSlice = createSlice({
  name: "configurations/airport-filters",
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<FilterAirportsQueryParams>) =>
        action.payload,
  },
});

export const {setFilters} = stateSlice.actions;

export default stateSlice.reducer;